import { useQuery } from "@jti/rest-api";

import { magento } from "../clients/getClient";
import type { ICountry, IRegion } from "../types/CodegenTypes";

type Countries = {
  countries: (Pick<
    ICountry,
    "full_name_english" | "full_name_locale" | "id" | "three_letter_abbreviation" | "two_letter_abbreviation"
  > & {
    available_regions: Pick<IRegion, "id" | "code" | "name">[];
  })[];
  isLoadingData: boolean;
};

export const useCountries = (): Countries => {
  const { data, isLoading: isCountriesLoading } = useQuery(
    "getCountries",
    async () => await magento.getCountriesForProfile()
  );

  return {
    countries: data?.countries || [],
    isLoadingData: isCountriesLoading,
  };
};
